<template>
  <div class="footer-main">

    <div class="footer_bar">
          <p>主办单位:江西省住房和城乡建设培训网 江西省人居环境研究院版权所有</p>
    <p>由北京博奥网络教育科技股份有限公司提供技术支持</p>
    <p>
      邮编: 330077 地址:江西省人居环境研究院（江西省南昌市东湖区二七北路610号）
    </p>
      <span style="cursor: pointer" @click="handleInit"
        >京ICP备10211073号-25</span
      ><br />
      <span>关于我们 | 版权说明 I 隐私保护 | 联系我们 </span>
    </div>
    <!-- <p class="fooer-bottom">赣ICP备16006106号-1免责声明</p> -->
  </div>
</template>

<script>
export default {
  methods: {
    handleInit() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/footer.vue